export default __webpack_public_path__ + "static/media/congratulations-complet-mobile.17b8a4fb.webp";